import { AddressVm } from './AddressVm'

export class BusinessVm{
    Id: number = 0;
    Cvr: string = "";
    Name: string = "";
    Address: AddressVm = new AddressVm();
    Phone: string = "";
    Responsible: string = "";
    AuthorizationNumber: string = "";
    CprStatus: string = "";
}